export { obterDiaInicioFolha } from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/criterios-empregado'
